// src/components/pricingUnits/Table/PricingUnitsTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";

const PricingUnitsTableRow = ({
    pricingUnit,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(pricingUnit?.id);

    // Status styling
    const isActive = pricingUnit?.is_active === true || pricingUnit?.is_active === 1;
    const statusLabel = isActive
        ? (isArabic ? "نشط" : "Active")
        : (isArabic ? "غير نشط" : "Inactive");

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, pricingUnit?.id)}
                    inputProps={{ "aria-labelledby": `pricingUnit-${pricingUnit?.id}` }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, pricingUnit);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell>{serial}</TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {pricingUnit?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {pricingUnit?.name?.en || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {pricingUnit?.code || "-"}
            </TableCell>

            <TableCell>
                <Chip
                    label={statusLabel}
                    icon={isActive ? <CheckCircleIcon /> : <CancelIcon />}
                    size="small"
                    sx={{
                        backgroundColor: isActive
                            ? isDark ? "rgba(34, 197, 94, 0.2)" : "#DEF7EC"
                            : isDark ? "rgba(239, 68, 68, 0.2)" : "#FDE8E8",
                        color: isActive
                            ? isDark ? "#4ADE80" : "#03543F"
                            : isDark ? "#F87171" : "#9B1C1C",
                        fontWeight: 500,
                        "& .MuiChip-icon": {
                            color: isActive
                                ? isDark ? "#4ADE80" : "#03543F"
                                : isDark ? "#F87171" : "#9B1C1C",
                        }
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, pricingUnit);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default PricingUnitsTableRow;
